(function () {
    'use strict';

    angular
        .module('app')
        .controller('ErrorListController', eController);

    function eController($scope, $rootScope, $location, $window, $state, $filter, $stateParams, UserService, toaster) {
        var model = this;

        //if no id in url, id is 0
        $stateParams.id ? $scope.errorId = $stateParams.id : $scope.errorId = 0;

        $scope.backToList = function () {
            $location.url('/errors');
        }

        model.windowGridHeight = function () {
            if (window.outerHeight >= 768) {
                return window.innerHeight - 360;
            } else {
                //var size = $scope.filteredData.length < $scope.pageSize ? $scope.filteredData.length : $scope.pageSize;
                //return (size * gridOptions.rowHeight) + 46;
            }
        };
    }
})();
